import { DeleteButton } from './DeleteButton';
import { NewButton } from './NewButton';
import { SaveButton } from './SaveButton';

export const Buttons = {
    Delete: DeleteButton,
    New: NewButton,
    Save: SaveButton,
};